import { render } from "./GridSelectAndTextEditor.vue?vue&type=template&id=137f0e31"
import script from "./GridSelectAndTextEditor.vue?vue&type=script&lang=js"
export * from "./GridSelectAndTextEditor.vue?vue&type=script&lang=js"

import "./GridSelectAndTextEditor.vue?vue&type=style&index=0&id=137f0e31&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__